<template>
 <transition name="scale">
    <div
      class="customModal fillForm"
      v-show="visible"
      >
      <div class="title" >
        <div class="btns">
          <el-radio-group v-model="radioValue">
            <el-radio-button label="1">企业信息</el-radio-button>
          </el-radio-group>
        </div>
        <div @click="close" class="operate">
          <i class="fa fa-share fa-2" aria-hidden="true"></i>返回用户列表页
        </div>
      </div>
      <div class="content" v-if="visible">
        <el-tabs class="content" v-if="visible" value="1" type="card">
          <el-tab-pane label="通用信息页" name="1">
            <div class="block">
              <div class="title">请填写认证信息</div>
              <div class="content">
                <AppForm
                  v-if="visible"
                  cancenlMargin
                  hiddenBtns
                  ref="form"
                  formStyle="default"
                  :defaultValues="defaultValues"
                  :fields="formFields"
                  :rules="rules"/>
              </div>
            </div>
            <div class="block">
              <div class="title">上传资历信息</div>
              <div class="content">
                <el-table
                  ref="table"
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="cer"
                    label="凭证"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="有效期"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="operate"
                    label="操作"
                    >
                    <template slot-scope="scope">
                      <el-button type="primary" v-if="!scope.row.file && isChange" @click="openSelectImg(scope.row)" plain size="small">添加</el-button>
                      <el-button type="primary" v-if="scope.row.file && isChange" @click="changeTableImg(scope.row)" plain size="small">更改</el-button>
                      <el-button type="primary" v-if="scope.row.file" @click="readonlyImg(scope.row)" plain size="small">预览</el-button>
                      <el-button type="primary" v-if="scope.row.file && !isChange" plain size="small" @click="download(scope.row)">下载</el-button>
                      <!-- <el-button type="primary" v-if="scope.row.file && isChange" @click="deleteImg(item)" plain size="small">删除</el-button> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="btns" v-if="openType !== 'read'">
          <AppButton customType="default" @click="apply()" v-if="openType === 'audit'">同意</AppButton>
          <AppButton customType="default" @click="reject()" v-if="(openType === 'audit' || openType === 'edit') && is_apply !== 3 ">拒绝</AppButton>
          <AppButton customType="default" v-if="isChange" @click ="submit" :loading="loading">提交保存</AppButton>
        </div>
      </div>
      <el-dialog :title="'资质添加'" :visible="upImgVisible" width="500px" @close="upImgVisible = false;" :modal="false">
        <div class="cerName">上传证书名称： {{addImgTitle}}</div>
        图片： <UploadImg v-model="imgs" :limit="1" pathType="certificate"/><br />
        有效期：<el-date-picker v-model="addExpiryData" value-format="yyyy-MM-dd"/>
        <span slot="footer">
          <el-button type="primary" @click="saveImg" size="small" >保存</el-button>
        </span>
      </el-dialog>
      <Modal :visible.sync="dialogVisible" @cancel="closeView" :footer="null" width="60%" :zIndex="3000">
        <img width="100%" :src="dialogImageUrl" alt="图片异常">
      </Modal>
    </div>
  </transition>
</template>

<script>
import UploadImg from '../../components/uploadImg/uploadImg.component';
import { Modal } from 'ant-design-vue';
import { UserService } from '../../service/user.service';
import { WebsiteService } from '../../service/website.service';
import { MessageBox } from 'element-ui';

const formFields = [
          { type: 'input', key: 'corporate_name', label: '企业名称', span: 8 },
          { type: 'input', key: 'legal_person', label: '企业法人代表', span: 8 },
          { type: 'input', key: 'legal_person_card_id', label: '企业法人身份证', span: 8 },
          { type: 'date', key: 'legal_person_card_id_expires_time', label: '身份证有效期', valueFormat: 'yyyy-MM-dd', span: 8 },
          { type: 'input', key: 'contacts', label: '企业联系人', span: 8 },
          { type: 'number', key: 'mobile', label: '联系人电话', span: 8 },
          { type: 'input', key: 'tel_phone', label: '固定电话', span: 8 },
          { type: 'input', key: 'corporate_type', label: '企业类型', span: 8 },
          { type: 'antdCascader', options: [], key: 'province', label: '所属区域', fieldNames: { label: 'name', value: 'id', children: 'children' }, span: 8 },
          { type: 'select', key: 'business_id', label: 'ERP企业', options: [], span: 8 },
          { type: 'textarea', rows: 2, key: 'address', label: '详细地址', span: 24 },
        ];
const tableData = [
  { cer: '药品经营许可证', value: 'management_license' },
  { cer: '营业执照', value: 'business_license' },
  { cer: 'GSP证', value: 'gps_license' },
  { cer: '质保书', value: 'warranty_book' },
  { cer: '采购&收货授权委托书', value: 'authorised_letter' },
  { cer: '需附身份证复印件', value: 'id_copy' },
  { cer: '组织机构代码证税务登记证', value: 'tax_certificate' },
  { cer: '医疗机构许可证', value: 'medical_license' },
]
  export default {
    name: 'userEnterprise',
    components: { UploadImg, Modal },
    data() {
      var provinceValidator = (rule, value, callback) => {
        if (!value[0]) {
          callback(new Error('请选择省份'));
        } else if (!value[1]) {
          callback(new Error('请选择城市'));
        } else if (!value[2]) {
          callback(new Error('请选择区县'));
        } else if (!value[3]) {
          callback(new Error('请选择街道'));
        } else if (!value) {
          callback(new Error('请选择所属区域'));
        } else {
          callback();
        }
      };
      return {
        visible: false,
        upImgVisible: false,
        imgs: [],
        tableData,
        radioValue: '1',
        formFields,
        is_apply:'',
        defaultValues: {},
        rules:{
          corporate_name: [{ required: true, message: '请填写企业名称'}],
          legal_person: [{ required: true, message: '请填写企业法人代表'}],
          legal_person_card_id: [{ required: true, message: '请填写企业法人身份证'}],
          contacts: [{ required: true, message: '请填写企业联系人'}],
          mobile: [{ required: true, message: '请填写联系人电话'}],
          province: [{ validator: provinceValidator }],
          corporate_type: [{ required: true, message: '请填写企业类型'}],
          address: [{ required: true, message: '请填写详细地址'}],
        },
        
        loading: false,
        addImgField: '',
        addImgTitle: '',
        openType: '', // ‘edit | add | read | audit
        dialogVisible: false,
        dialogImageUrl: '',
        addExpiryData: null,
      }
    },
    async created() {
      const data = await UserService.getErpEnterPrise();
      if (data instanceof Array) {
        data.forEach(item => {
          item.label = item.name;
          item.value = item.business_id;
        });
        this.formFields[this.formFields.length - 2].options = data;
      }
      
      this.getTreeData();
      this.formFields[8].loadData = this.loadData;
    },
    computed: {
      isChange() {
        return this.openType === 'add' || this.openType === 'edit';
      }
    },
    methods: {
       async loadData (selectedOptions) {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        const { level, id } = targetOption;
        let data;
        try {
          data = await WebsiteService.getNodeSon(id);
        } catch(e) {
          return ;
        } finally {
          targetOption.loading = false;
        }
        data.forEach(item => {
          item.level = level ? level + 1 : 1;
          if (item.level === 3) {
            item.isLeaf = true;
          } else {
            item.isLeaf = false;
          }
        });
        targetOption.children = data;
        this.formFields[8].options = [...this.formFields[8].options];
      },
      async getTreeData() {
        const data = await WebsiteService.getListByRegion();
        data.forEach(item => {
          item.isLeaf = false;
        });
        this.formFields[8].options = data;
      },
      async open(type, data) {
        this.is_apply = data.is_apply
       this.openType = type;
       this.formFields[8].key = 'province';
       this.formFields.forEach(item => {
          item.readonly = false;
        });
      this.formFields.splice(11, 1);
      const res = await UserService.getCompanyInfo(data.user_id);
       if (type === 'edit') {
         this.handleImg(res);
         if (res.province) {
           const treeData = JSON.parse(JSON.stringify(this.formFields[8].options));
           for (let i = 0; i < treeData.length; i++) {
             if (res.province === treeData[i].id) {
               treeData[i].children = await this.handleTreeDefaultValue(res.province, res.city, res.district);
             }
           }
           if (res.province) {
              res.province = [res.province];
              if (res.city) {
                res.province.push(res.city)
                if (res.district) {
                  res.province.push(res.district)
                  if (res.town) {
                    res.province.push(res.town)
                  }
                }
              }
           } else {
             res.province = [];
           }
           this.formFields[8].options = treeData;
         }
         this.defaultValues = res;
       } else if (type === 'read' || type === 'audit') {
         if(data.is_apply === 3) {
           this.formFields.push({ type: 'textarea', rows: 2, key: 'reject_reason', label: '拒绝原因', span: 24 });
         }
          this.handleImg(res);
          if (res.province) {
           this.formFields[8].key = 'area';
         }
         this.formFields.forEach(item => {
           item.readonly = true;
         });
         this.defaultValues = res;
       } else {
          res.province = [];
          this.defaultValues = res;
       }
        this.tableData.forEach(item => {
          if (res[item.value]) {
            item.time = res[item.value + '_expires_time'];
          }
        })
        this.visible = true;
      },
      async handleTreeDefaultValue(province, city, district) {
        const list = [];
        if (province) { list.push(WebsiteService.getNodeSon(province)) }
        if (city) { list.push(WebsiteService.getNodeSon(city)) }
        if (district) { list.push(WebsiteService.getNodeSon(district)) }
        const [cityList, districtList, twonList ] = await Promise.all(list);
        let children = [];
        if (cityList && cityList.length) {
          children = cityList.map(v => {v.isLeaf = false; return v;});
          if (districtList && districtList.length) {
            const foundCity = children.find(v => v.id === city);
            (foundCity || {}).children = districtList.map(v => {v.isLeaf = false; return v;});
            if (twonList && twonList.length) {
              ((foundCity || {}).children.find(v => v.id === district) || {}).children = twonList;
            }
          }
        }
        return children;
      },
      handleImg(data) {
        this.tableData.forEach(item => {
          if (data.hasOwnProperty(item.value) && data[item.value]) {
            item.file = [{
              uid: 1,
              name: '图片异常',
              status: 'done',
              url: UserService.spliceImg(data[item.value]),
            }]
          } else {
            item.file = undefined;
          }
        })
      },
      close() {
        this.visible = false;
      },
      openSelectImg(item) {
        this.addImgTitle = item.cer;
        this.addImgField = item.value;
        this.imgs = [];
        this.upImgVisible = true;
      },
      changeTableImg(item) {
        this.addImgTitle = item.cer;
        this.addImgField = item.value;
        this.imgs = item.file;
        this.addExpiryData = item.time;
        this.upImgVisible = true;
      },
      readonlyImg(item) {
        this.dialogVisible = true;
        this.dialogImageUrl = item.file[0].url || item.file[0].thumbUrl;
      },
      saveImg() {
        const list = [];
        this.tableData.forEach(item => {
          if (item.value === this.addImgField) {
            item.file = [...this.imgs];
            item.time = this.addExpiryData;
          }
          list.push(item);
        });
        this.tableData = list;
        this.upImgVisible = false;
      },
      deleteImg(item) {
        this.tableData.forEach(v => {
          if (v.value === item.value) {
            v.file = undefined;
          }
        });
      },
      closeView() {
        this.dialogVisible = false;
      },
      download(item) {
        // downloadFile(item.file[0].url || item.file[0].thumbUrl);
        UserService.download(item.file[0].url || item.file[0].thumbUrl)
      },
      async apply() {
        await UserService.applyAudit(this.defaultValues.user_id);
        this.$emit('success');
        this.close();
      },
      async reject() {
        const { value } = await MessageBox.prompt('请输入拒绝理由', '拒绝', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        });
        await UserService.rejectAudit(this.defaultValues.user_id, value);
        this.$emit('success');
        this.close();
      },
      async submit() {
        const result = await this.$refs.form.submit();
        if (result) {
          const data = JSON.parse(JSON.stringify(this.defaultValues));
          data.town = data.province[3];
          data.district = data.province[2];
          data.city = data.province[1];
          data.province = data.province[0];
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].file) {
              data[this.tableData[i].value] = this.tableData[i].file;
              data[this.tableData[i].value + '_expires_time'] = this.tableData[i].time;
              await UserService.extractImg(data, this.tableData[i].value, false, 'certificate');
            }
          }
          await UserService.saveCompany(data);
          await this.apply();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.block {
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
  box-sizing: border-box;
  .title {
    color: #333;
    font-size: 16px;
    height: 50px;
    margin: 10px 0;
  }
  .content{
    padding: 0 50px;
  }
}
.cerName {
  margin-bottom: 30px;
}
</style>